import React from 'react';

const Accordion = ({ children }) => <div>{children}</div>;

export default Accordion;
